export default __webpack_public_path__ + "static/media/wordpresBottl.228e9634.png";